<template src="./profilo.html"></template>

<script>
import PrivacyDialog from "@/components/dialog/PrivacyDialog.vue";
import { save_userAccount } from "@/api/api.user.js";

export default {
  props: {
  },

  components: {
    PrivacyDialog,
  },

  data: () => ({
    loading: false,
    e1: false,
    e2: false,
    validFormUtente: true,
    disabilitaBtnSaveAccount: false,
    alertElaborazione: "",
    tipo: "success",

    datiAccount: {
      Utente: "",
      PasswordAttuale: "",
      Password: "",
      PasswordRepeat: "",
      Mail: "",
      Telefono: "",
      UserId: null,
    },

    dialogPrivacy: false,
  }),

  methods: {
    caricaDati() {
      this.loading = true;

      this.alertElaborazione = "";
      this.datiAccount.Utente = this.$store.getters["user/getNome"];
      this.datiAccount.Mail = this.$store.getters["user/getMail"];
      this.datiAccount.Telefono = this.$store.getters["user/getTelefono"];
      this.datiAccount.PasswordAttuale = "";
      this.datiAccount.Password = "";
      this.datiAccount.PasswordRepeat = "";
      this.datiAccount.UserId = this.$store.getters["user/getUserId"];

      this.loading = false;
    },

    salvaAccount() {
      // Validazione
      if (this.$refs.formPwd.validate() == false) {
        return;
      }

      this.$confirm.open("Salva", "Vuoi salvare i dati?").then((confirm) => {
        if (!confirm) return;
        this.disabilitaBtnSaveAccount = true;

        this.loading = true;
        save_userAccount(this.datiAccount)
          .then((res) => {
            this.alertElaborazione =
              "Dati aggiornati. Per rendere effettive le modifiche uscire e rientrare nell'area riservata.";
            this.tipo = "success";
            this.disabilitaBtnSaveAccount = false;
          })
          .catch((err) => {
            console.log("Profilo.vue " + err);
            this.disabilitaBtnSaveAccount = false;

            this.alertElaborazione = err.response.data.Message;
            this.tipo = "warning";
          });
        this.loading = false;
      });
    },

    refresh() {
      this.caricaDati();
    },

    apriDialogPrivacy() {
      this.dialogPrivacy = true;
    }
  },

  mounted() {
    this.caricaDati();
  },

  /* created() {
    this.caricaDati();
  }, */

  watch: {
    getUtente() {
      this.caricaDati();
    },
  },

  computed: {
    GetLoading() {
      return this.$store.getters["app/getLoading"];
    },

    getUtente() {
      return this.$store.getters["user/getNome"];
    },
  },
};
</script>